export enum MobilePaymentMethod {
  ApplePay = 'applePay',
  GooglePay = 'googlePay',
}

export default MobilePaymentMethod;
